import fixture from './CompanyRegistrationProfileInfo.get.json';
import { fetchFixture } from 'utils/fetchFixture';
import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    ICompanyRegistrationProfileInfoClient,
} from 'interfaceAdapter/gatewaySchemas/ICompanyRegistrationProfileInfoClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/company/registration_profile_info`;

export class CompanyRegistrationProfileInfoClient implements ICompanyRegistrationProfileInfoClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { mock = false } = input;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = mock
                ? await fetchFixture(fixture)
                : await fetch(PATH, {
                      method,
                      headers,
                  });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
